function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRede({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff7803",
    d: "M 489.5,262.5 C 483.369,261.17 476.869,260.503 470,260.5C 463.325,260.5 456.825,260.834 450.5,261.5C 457.183,316.136 433.183,343.469 378.5,343.5C 364.506,343.964 350.839,342.131 337.5,338C 325.285,333.117 316.285,324.784 310.5,313C 282.5,312.667 254.5,312.333 226.5,312C 200.765,309.398 182.265,296.565 171,273.5C 169.362,269.278 168.195,264.945 167.5,260.5C 152.797,260.149 138.13,260.649 123.5,262C 107.548,265.619 98.0477,275.452 95,291.5C 94.6667,312.167 94.3333,332.833 94,353.5C 93.1667,355.667 91.6667,357.167 89.5,358C 80.8333,358.667 72.1667,358.667 63.5,358C 61.9512,356.786 60.7845,355.286 60,353.5C 59.5,312.835 59.3333,272.168 59.5,231.5C 70.8333,231.5 82.1667,231.5 93.5,231.5C 93.3343,235.846 93.501,240.179 94,244.5C 102.868,235.317 113.701,230.317 126.5,229.5C 140.541,230.149 154.208,229.482 167.5,227.5C 174.527,198.976 192.527,181.809 221.5,176C 233.5,175.333 245.5,175.333 257.5,176C 287.151,180.435 299.985,197.602 296,227.5C 292.318,246.512 280.818,257.346 261.5,260C 242.178,260.993 222.844,261.826 203.5,262.5C 208.32,271.915 215.987,277.415 226.5,279C 253.165,279.5 279.831,279.667 306.5,279.5C 308.893,257.612 320.226,242.446 340.5,234C 346.948,231.506 353.615,229.84 360.5,229C 378.497,228.5 396.497,228.333 414.5,228.5C 414.5,201.167 414.5,173.833 414.5,146.5C 425.833,146.5 437.167,146.5 448.5,146.5C 448.5,173.833 448.5,201.167 448.5,228.5C 462.167,228.5 475.833,228.5 489.5,228.5C 494.814,202.68 510.148,185.846 535.5,178C 553.503,174.667 571.503,174.667 589.5,178C 608.572,184.242 618.239,197.408 618.5,217.5C 619.672,237.465 611.005,250.965 592.5,258C 586.282,259.722 579.949,260.722 573.5,261C 557.49,261.167 541.49,261.667 525.5,262.5C 529.815,271.977 537.148,277.477 547.5,279C 599.5,279.333 651.5,279.667 703.5,280C 705.667,280.833 707.167,282.333 708,284.5C 708.667,292.167 708.667,299.833 708,307.5C 707.167,309.667 705.667,311.167 703.5,312C 649.142,312.965 594.809,312.632 540.5,311C 513.442,305.181 496.442,289.014 489.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffdfb",
    d: "M 225.5,207.5 C 235.912,207.074 246.246,207.574 256.5,209C 261.22,212.298 262.72,216.798 261,222.5C 259.52,225.663 257.02,227.496 253.5,228C 236.503,228.5 219.503,228.667 202.5,228.5C 205.401,216.265 213.068,209.265 225.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffdfb",
    d: "M 572.5,228.5 C 556.325,228.83 540.325,228.496 524.5,227.5C 527.439,216.73 534.439,210.23 545.5,208C 555.5,207.333 565.5,207.333 575.5,208C 583.946,211.629 585.78,217.462 581,225.5C 578.508,227.497 575.675,228.497 572.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9c46",
    d: "M 167.5,227.5 C 154.208,229.482 140.541,230.149 126.5,229.5C 140.068,228.817 153.735,228.15 167.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff983e",
    d: "M 524.5,227.5 C 540.325,228.496 556.325,228.83 572.5,228.5C 556.328,229.827 539.995,229.827 523.5,228.5C 523.624,227.893 523.957,227.56 524.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdcbd",
    d: "M 450.5,261.5 C 456.825,260.834 463.325,260.5 470,260.5C 476.869,260.503 483.369,261.17 489.5,262.5C 476.579,261.52 463.579,261.186 450.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefd",
    d: "M 358.5,261.5 C 377.167,261.5 395.833,261.5 414.5,261.5C 414.666,271.506 414.5,281.506 414,291.5C 412.042,300.793 406.542,306.96 397.5,310C 384.833,310.667 372.167,310.667 359.5,310C 342.447,304.397 336.614,292.897 342,275.5C 345.685,268.591 351.185,263.924 358.5,261.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRede);
export default __webpack_public_path__ + "static/media/rede.86822894dcbe00c3511cc5d7ca51b747.svg";
export { ForwardRef as ReactComponent };